import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { Skeleton } from "antd";
import { observer } from "mobx-react";
import { useState } from "react";
import { ProgressIndicator } from "./ProgressIndicator.js";
import { useStores } from "../../../../store/stores.js";
import { markdownBold } from "../../utils/markdownBold.js";
/**
 * Hero: product logo, value proposition, sticky progress stepper. Styling
 * in `.checkout-v2-hero*` / `.checkout-v2-sticky-stepper*` (incl. admin-bar
 * offset and blur fade).
 */ const HeroSection = observer(()=>{
    const { checkoutV2Store } = useStores();
    const { product } = checkoutV2Store;
    if (!product) {
        return null;
    }
    const { data: { productPlan: { product: { name, logoSquare, logoFull, headlineValueProposition } } } } = product;
    const logoUrl = logoFull?.downloadUrl ?? logoSquare?.downloadUrl;
    // Keep the skeleton in place until the <img> is paintable (SVGs load
    // after React mounts on slow networks, and showing the bare tag flashes
    // alt-text). `onError` unblocks the hero if the asset 404s. The
    // container's matching `min-height` in SCSS reserves vertical space so
    // skeleton→img doesn't shift the page.
    const [logoLoaded, setLogoLoaded] = useState(false);
    const markLogoReady = ()=>setLogoLoaded(true);
    return /*#__PURE__*/ _jsxs(_Fragment, {
        children: [
            /*#__PURE__*/ _jsxs("div", {
                className: "checkout-v2-hero",
                children: [
                    logoUrl && /*#__PURE__*/ _jsxs("div", {
                        className: "checkout-v2-hero__logo",
                        children: [
                            !logoLoaded && /*#__PURE__*/ _jsx(Skeleton.Input, {
                                active: true,
                                size: "large",
                                className: "checkout-v2-hero__logo-skeleton"
                            }),
                            /*#__PURE__*/ _jsx("img", {
                                src: logoUrl,
                                alt: name,
                                onLoad: markLogoReady,
                                onError: markLogoReady,
                                style: {
                                    display: logoLoaded ? undefined : "none"
                                }
                            })
                        ]
                    }),
                    headlineValueProposition && /*#__PURE__*/ _jsx("div", {
                        className: "checkout-v2-hero__headline",
                        children: markdownBold(headlineValueProposition)
                    })
                ]
            }),
            /*#__PURE__*/ _jsxs("div", {
                className: "checkout-v2-sticky-stepper",
                children: [
                    /*#__PURE__*/ _jsx("div", {
                        "aria-hidden": true,
                        className: "checkout-v2-sticky-stepper__backdrop"
                    }),
                    /*#__PURE__*/ _jsx("div", {
                        className: "checkout-v2-sticky-stepper__content",
                        children: /*#__PURE__*/ _jsx(ProgressIndicator, {})
                    })
                ]
            })
        ]
    });
});
export { HeroSection };
